import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext.jsx';
import { createWhatsNew } from '../lib/whatsNew.js';
import WhatsNewForm from '../components/whatsNew/WhatsNewForm.jsx';

export default function WhatsNewNew() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { user, isAdmin, isActive } = useAuth();
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(null);
  // "Add to What's New" on a bibliography entry lands here with the fields
  // pre-filled; the state is only present on that navigation.
  const prefill = state?.prefill ?? undefined;

  if (!isActive) {
    return (
      <div className="mx-auto max-w-2xl px-8 pb-20 pt-32">
        <div className="cta-box">
          <h1 className="cta-title">{t('bibliography.form.notActiveTitle')}</h1>
          <p className="cta-body">{t('bibliography.form.notActiveBody')}</p>
        </div>
      </div>
    );
  }

  if (submitted) {
    const wasPublished = submitted.status === 'published';
    return (
      <div className="mx-auto max-w-2xl px-8 pb-20 pt-32">
        <div className="cta-box">
          <div className="section-label">
            {wasPublished ? t('whatsNew.form.publishedLabel') : t('whatsNew.form.submittedLabel')}
          </div>
          <h1 className="cta-title">{submitted.title}</h1>
          <p className="cta-body">
            {wasPublished
              ? t('whatsNew.form.publishedBody')
              : t('whatsNew.form.submittedBody')}
          </p>
          <button type="button" className="btn-primary" onClick={() => navigate('/whats-new')}>
            {t('whatsNew.form.backToList')}
          </button>
        </div>
      </div>
    );
  }

  async function handleSubmit(form) {
    setBusy(true);
    try {
      const created = await createWhatsNew(form, { authorId: user.id, asAdmin: isAdmin });
      setSubmitted(created);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-3xl px-6 pb-20 pt-28">
      <header className="mb-8">
        <div className="section-label">{t('whatsNew.form.newLabel')}</div>
        <h1 className="font-serif text-3xl font-semibold text-cream">
          {t('whatsNew.form.newHeading')}
        </h1>
        <p className="mt-2 text-sm text-ink-secondary">
          {isAdmin
            ? t('whatsNew.form.newSubheadingAdmin')
            : t('whatsNew.form.newSubheadingCollaborator')}
        </p>
      </header>

      <WhatsNewForm
        initialValue={prefill}
        submitLabel={isAdmin ? t('whatsNew.form.publish') : t('whatsNew.form.submitForReview')}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/whats-new')}
        busy={busy}
      />
    </div>
  );
}
